import styled from "styled-components"
import CloseIcon from "../img/close.svg"
const SubMenuConBack = styled.div`
  z-index: 6;
  position: fixed;
  left: 0px;
  top: 0px;
  height: 0px;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  opacity: 93%;
`

const FrontTypo = styled.div`
  display: flex;
  justify-content: center;
  background-color: #111;
  border-bottom: 1px solid #333;
  height: auto;
  flex-direction: row;
`

const MainTypo = styled.div`
  margin-left: 4rem;
  padding: 3rem;
  padding-right: 0rem;
  font-family: "title-font";
  color: #fff;
  text-align: center;
  font-size: 3.5rem;
  line-height: 4rem;
  align-items: center;

  @media (max-width: 920px) {
    font-size: 3rem;
    line-height: 3.5rem;
  }
  align-items: center;
  @media (max-width: 500px) {
    margin-left: 0rem;
    margin-right: 3rem;
  }
`

const SubTypo = styled.div`
  padding: 3.2rem;
  padding-left: 0.5rem;
  vertical-align: bottom;
  font-family: "sub-font";
  color: #bbb;
  line-height: 0.7rem;
  font-size: 1.7rem;
  text-align: center;
  margin-top: 2rem;

  @media (max-width: 920px) {
    font-size: 1.5rem;
  }
  align-items: center;
  @media (max-width: 500px) {
    display: none;
  }
`

const Close = styled.div`
  position: fixed;
  top: 2.5rem;
  right: 2.5%;
  background-color: #fff;
  opacity: 15%;
  width: 48px;
  height: 48px;
  mask: url(${CloseIcon});

  &:hover {
    background-color: #f28d00;
    opacity: 70%;
  }
`

const SubMenuConFront = styled.div`
  z-index: 7;
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  border: 1px solid #888;
  width: 1248px;
  height: auto;

  border-radius: 2rem;
  overflow: hidden;
  @media (max-width: 1302px) {
    width: calc(100vw - 48px);
  }
  background-color: #fff;
`

function SubMenuCon({ title, sub, menuTrance, children, ...rest }) {
  return (
    <div>
      <SubMenuConFront>
        <FrontTypo>
          <MainTypo>{title}</MainTypo>
          <SubTypo>{sub}</SubTypo>
          <Close onClick={menuTrance}></Close>
        </FrontTypo>
        {children}
      </SubMenuConFront>

      <SubMenuConBack onClick={menuTrance}></SubMenuConBack>
    </div>
  )
}

export default SubMenuCon
